import { render, staticRenderFns } from "./StorageIndex.vue?vue&type=template&id=e0f2cec8&"
import script from "./StorageIndex.vue?vue&type=script&lang=js&"
export * from "./StorageIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports